import {  useEffect, useRef } from 'react'
import { useWallDispatch } from '../../../../../../../stateProviders/WallStateProvider';

export const EdgeTypeSubmenu:React.FC<{x:number,y:number}> = ({x,y}) => {

    const submenuRef = useRef<HTMLDivElement | null>(null)
    const foreignObjectRef = useRef<SVGForeignObjectElement | null>(null)
    const wallDispatch = useWallDispatch();

    //this will move the parent g to the bottom of the svg element, putting the submenu on top in the stacking order
    useEffect( () => {
        if(!foreignObjectRef.current) return
        const svg = document.querySelector('#drawspace')
        //get the closest g element to the foreignObject
        svg?.querySelector('g')?.appendChild(foreignObjectRef.current.parentNode as Node);
    },[foreignObjectRef.current])

    return (
        <foreignObject ref={foreignObjectRef}  x={x} y={y} className='w-[200px] h-[200px]'>
            <div style={{height:submenuRef.current?.offsetHeight}} ref={submenuRef} className="absolute z-[10] bg-white shadow-md flex flex-col p-[20px] border border-black">
                <button onClick={() => {
                    wallDispatch({wallType:'house'})
                }} className="">House</button>
                <button onClick={() => {
                    wallDispatch({wallType:'houseAttached'})
                }} className="">House Attached</button>
                <button onClick={() => {
                    wallDispatch({wallType:'railing'})
                }} className="">Railing</button>
                <button onClick={() => {
                    wallDispatch({wallType:'stairs'})
                }} className="">Stairs</button>
            </div>
        </foreignObject>
    )
}